import { render, staticRenderFns } from "./incidenceTable.vue?vue&type=template&id=943885ae&scoped=true"
import script from "./incidenceTable.vue?vue&type=script&lang=js"
export * from "./incidenceTable.vue?vue&type=script&lang=js"
import style0 from "./incidenceTable.vue?vue&type=style&index=0&id=943885ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943885ae",
  null
  
)

export default component.exports